import { Swiper } from 'swiper';

export default (node) => {
  const sliderEl = node.querySelector('[data-slider]');
  const buttonNext = node.querySelector('[data-next]');
  const buttonPrev = node.querySelector('[data-prev]');

  let sliderBreakpoints = {
    320: 1.5,
    480: 1.5,
    768: 2.8,
    1024: 4.2,
    1800: 4.2,
  };

  const initSlider = () => {
    const swiper = new Swiper(sliderEl, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      autoHeight: false,
      navigation: {
        nextEl: buttonNext,
        prevEl: buttonPrev,
      },
      on: {
        touchStart: function () {
          // Add 'grabbing' class on touch start
          swiper.slides.forEach((slide) => {
            slide.classList.add('cursor-grabbing');
          });
        },
        touchEnd: function () {
          // Remove 'grabbing' class on touch end
          swiper.slides.forEach((slide) => {
            slide.classList.remove('cursor-grabbing');
          });
        },
      },
      breakpoints: {
        320: {
          slidesPerView: sliderBreakpoints['320'],
        },
        480: {
          slidesPerView: sliderBreakpoints['480'],
        },
        768: {
          slidesPerView: sliderBreakpoints['768'],
        },
        1024: {
          slidesPerView: sliderBreakpoints['1024'],
        },
        1800: {
          slidesPerView: sliderBreakpoints['1800'],
        },
      },
    });
  };

  /**
   * Init
   */
  initSlider();
};
